import { css, Paragraph, Spinner, styled } from 'canoe';
import React from 'react';

const Wrapper = styled.div`
  ${({ theme }) => css`
    position: absolute;
    inset: 0;
    z-index: 2;
    background-color: ${theme.colors.GlitterGrayL20};
    padding-top: ${theme.spaces.xxl};
    min-width: 100%;
    min-height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
  `}
`;

export const SnapshotLoader = () => (
  <Wrapper>
    <Spinner size="huge" />
    <Paragraph size="short" color="OnyxGray">
      Loading Snapshot ...
    </Paragraph>
  </Wrapper>
);
